"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var index_1 = require("../../index");
var helpers_1 = require("../../helpers");
function DraggableItem(_a) {
    var _id = _a._id, index = _a.index, _b = _a.as, Container = _b === void 0 ? "div" : _b, children = _a.children, className = _a.className, style = _a.style;
    var _c = (0, index_1.useDraggableList)(), grid = _c.grid, inPortal = _c.inPortal;
    var portal;
    if (inPortal) {
        portal = document.createElement("div");
        document.body.appendChild(portal);
    }
    return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { draggableId: _id, index: index }, function (provided, snapshot) {
        var child = (react_1.default.createElement(Container, __assign({ ref: provided.innerRef, className: className }, provided.draggableProps, provided.dragHandleProps, { style: __assign(__assign({}, (0, helpers_1.getDraggableItemStyle)(grid, snapshot.isDragging, provided.draggableProps.style)), style) }), children));
        if (!inPortal || !snapshot.isDragging)
            return child;
        return (0, react_dom_1.createPortal)(child, portal);
    }));
}
exports.default = DraggableItem;
//# sourceMappingURL=index.js.map